/**
 * Returns a consistent pastel color hash for a given string.
 * Generates an HSL background color based on the input.
 * @param str Input string (e.g., owner or actor title)
 * @returns HSL color string
 */
export function getColorFromHash(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const h = Math.abs(hash) % (360 / 5);
  // Pastel saturation and lightness for bright backgrounds
  return `hsl(${h * 5}, 60%, 70%)`;
}